export function ContactPage() {
  const mailtoLink = 'mailto:developer@maxint.dev?subject=Contact%20from%20Privacy%20Forum';

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-slate-100 mb-8">
          Contact Us
        </h1>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Email Contact */}
          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8">
            <h2 className="text-2xl md:text-3xl font-semibold text-slate-900 dark:text-slate-100 mb-6">
              Get in Touch
            </h2>

            <p className="text-base text-slate-700 dark:text-slate-300 mb-8">
              Have questions, feedback, or need support? Click the email address below to send us a message.
            </p>

            <div className="text-center py-8">
              <a
                href={mailtoLink}
                className="inline-flex items-center justify-center text-2xl font-semibold text-brand-600 dark:text-brand-400 hover:text-brand-700 dark:hover:text-brand-300 transition-colors"
              >
                <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                developer@maxint.dev
              </a>
            </div>

            <p className="text-sm text-center text-slate-500 dark:text-slate-400 mt-6">
              Clicking the email will open your default email client
            </p>
          </div>

          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8">
              <h2 className="text-2xl md:text-3xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
                Get in touch
              </h2>
              <p className="text-base text-slate-700 dark:text-slate-300 mb-6">
                Have questions, feedback, or need support? We're here to help!
              </p>

              <div className="space-y-5">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-brand-100 dark:bg-brand-900/30 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-6 h-6 text-brand-600 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Email</h3>
                    <p className="text-base text-slate-600 dark:text-slate-400">developer@maxint.dev</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-brand-100 dark:bg-brand-900/30 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-6 h-6 text-brand-600 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Community Forum</h3>
                    <p className="text-base text-slate-600 dark:text-slate-400">Ask questions in our community</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-brand-100 dark:bg-brand-900/30 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-6 h-6 text-brand-600 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Response Time</h3>
                    <p className="text-base text-slate-600 dark:text-slate-400">We typically respond within 24-48 hours</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8">
              <h3 className="text-xl md:text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
                FAQ
              </h3>
              <p className="text-base text-slate-700 dark:text-slate-300">
                Before reaching out, check our frequently asked questions section for quick answers to common inquiries.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
